type PickerStrings = {
  ok: string
  cancel: string
  switch_language: string
  header: string
  header_body: string
  title: string
  search_text: string
  connect_button: string
  select_model: string
  connect_to_prime_title: string
  connect_to_prime_body: string
  customizer_title: string
  disable_rotation: string
  rotation_speed: string
  field_of_view: string
  confirm: string
  rotation_range: string
  tilt: string
  wall_mounted: string
  scale_locked: string
  reset: string
  link_account: string
  link_account_button: string
  order_label: string
  date_modified: string
  date_created: string
  size: string
  descending: string
  ascending: string
}

const DEFAULT_LOCALE = 'en-US'

export const pickerMessages: Record<string, PickerStrings> = {
  'en-US': {
    ok: 'Ok',
    cancel: 'Cancel',
    switch_language: 'switch',
    header: 'Client Page Mockup',
    header_body:
      "I am a client page, below is the Monocle Picker Component that I'm displaying on my site",
    title: 'Model Picker',
    search_text: 'Search Models',
    connect_button: 'Connect',
    select_model: 'Select Model',
    connect_to_prime_title: 'Connect to iPhone',
    connect_to_prime_body:
      "Use your Camera app to scan this QR code. <br/><br/><b>First Time Users</b> you'll be asked to install the app. Once installed scan this QR code again to sign in automatically. Once connected, your scans will appear here.",
    customizer_title: 'Custom Controls',
    disable_rotation: 'Disable Rotation',
    rotation_speed: 'Rotation Speed',
    field_of_view: 'Zoom',
    confirm: 'Confirm',
    rotation_range: 'Rotation Range',
    tilt: 'Tilt',
    wall_mounted: 'Wall Mounted',
    scale_locked: 'Scale Locked',
    reset: 'Reset to default settings',
    link_account:
      'It looks like there is already a Monocle 3D account associated with this email address. Click the button below to finish setup.',
    link_account_button: 'Link My Account',
    order_label: 'Order',
    date_modified: 'Date Modified',
    date_created: 'Date Created',
    size: 'Size',
    descending: 'Descending',
    ascending: 'Ascending',
  },

  'fr-FR': {
    ok: 'Ok',
    cancel: 'Annuler',
    switch_language: 'switch',
    header: 'Maquette de Page Client',
    header_body:
      "Je suis une page client, ci-dessous se trouve le composant Monocle Picker que j'affiche sur mon site",
    title: 'Sélecteur de Modèles',
    search_text: 'Rechercher des Modèles',
    connect_button: 'Connecter',
    select_model: 'Sélectionner un Modèle',
    connect_to_prime_title: 'Connecter à iPhone',
    connect_to_prime_body:
      "Utilisez votre application Appareil photo pour scanner ce QR code. <br/><br/><b>Nouveaux utilisateurs</b> on vous demandera d'installer l'application. Une fois installée, scannez à nouveau ce QR code pour vous connecter automatiquement. Une fois connecté, vos scans apparaîtront ici.",
    customizer_title: 'Contrôles Personnalisés',
    disable_rotation: 'Désactiver la Rotation',
    rotation_speed: 'Vitesse de Rotation',
    field_of_view: 'Zoom',
    confirm: 'Confirmer',
    rotation_range: 'Plage de rotation',
    tilt: 'Inclinaison',
    wall_mounted: 'Monté au mur',
    scale_locked: 'Échelle verrouillée',
    reset: 'Réinitialiser aux paramètres par défaut',
    link_account:
      "Il semble qu'il existe déjà un compte Monocle3D associé à cette adresse e-mail. Cliquez sur le bouton ci-dessous pour terminer la configuration.",
    link_account_button: 'Lier mon compte',
    order_label: 'Trier',
    date_modified: 'Date Modified',
    date_created: 'Date Created',
    size: 'Size',
    descending: 'Descending',
    ascending: 'Ascending',
  },

  'ja-JP': {
    ok: 'Ok',
    cancel: 'キャンセル',
    switch_language: 'switch',
    header: 'クライアントページモックアップ',
    header_body:
      '私はクライアントページです。以下は、私のサイトに表示しているMonocle Pickerコンポーネントです',
    title: 'モデルピッカー',
    search_text: 'モデルを検索',
    connect_button: '接続',
    select_model: 'モデルを選択',
    connect_to_prime_title: 'iPhoneに接続',
    connect_to_prime_body:
      'カメラアプリを使用してこのQRコードをスキャンしてください。<br/><br/><b>初回ユーザー</b>の方はアプリのインストールを求められます。インストール後、このQRコードを再度スキャンして自動的にサインインしてください。接続すると、スキャンしたものがここに表示されます。',
    customizer_title: 'カスタムコントロール',
    disable_rotation: '回転を無効にする',
    rotation_speed: '回転速度',
    field_of_view: 'ズーム',
    confirm: '確定',
    rotation_range: '回転範囲',
    tilt: '傾斜',
    wall_mounted: '壁取り付け',
    scale_locked: 'スケール固定',
    reset: 'デフォルト設定にリセット',
    link_account:
      'このメールアドレスにはすでにMonocle3Dアカウントが関連付けられているようです。セットアップを完了するには、以下のボタンをクリックしてください。',
    link_account_button: 'アカウントをリンクする',
    order_label: '並び順',
    date_modified: '更新日',
    date_created: '作成日',
    size: 'サイズ',
    descending: '降順',
    ascending: '昇順',
  },

  'it-IT': {
    ok: 'Ok',
    cancel: 'Annulla',
    switch_language: 'cambia',
    header: 'Mockup Pagina Cliente',
    header_body:
      "Sono una pagina cliente, qui sotto c'è il componente Monocle Picker che sto mostrando sul mio sito",
    title: 'Selettore Modello',
    search_text: 'Cerca Modelli',
    connect_button: 'Collega',
    select_model: 'Seleziona Modello',
    connect_to_prime_title: 'Connetti a iPhone',
    connect_to_prime_body:
      "Usa la tua app Fotocamera per scansionare questo codice QR. <br/><br/><b>Primi utenti</b> vi verrà chiesto di installare l'app. Una volta installata, scansionate di nuovo questo codice QR per accedere automaticamente. Una volta connessi, i vostri scan appariranno qui.",
    customizer_title: 'Controlli Personalizzati',
    disable_rotation: 'Disabilita Rotazione',
    rotation_speed: 'Velocità di Rotazione',
    field_of_view: 'Zoom',
    confirm: 'Conferma',
    rotation_range: 'Intervallo di rotazione',
    tilt: 'Inclinazione',
    wall_mounted: 'Montato a parete',
    scale_locked: 'Scala bloccata',
    reset: 'Ripristina le impostazioni predefinite',
    link_account:
      'Sembra che ci sia già un account Monocle3D associato a questo indirizzo email. Fare clic sul pulsante qui sotto per completare la configurazione.',
    link_account_button: 'Collega il mio account',
    order_label: 'Ordine',
    date_modified: 'Data di modifica',
    date_created: 'Data di creazione',
    size: 'Dimensione',
    descending: 'Decrescente',
    ascending: 'Crescente',
  },
}

export const getStrings = (language: string): PickerStrings => {
  if (pickerMessages[language]) {
    return pickerMessages[language]
  }

  const baseLang = language.split('-')[0]
  const fallbackKey = `${baseLang}-US`

  return pickerMessages[fallbackKey] ?? pickerMessages[DEFAULT_LOCALE]!
}

export default pickerMessages
